import "./Comentarios.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CargandoSpinner from "../../0. Utilidades/loadingSpinner"; // Import the spinner component
import PersonAvatar from "../../0. Utilidades/PersonAvatar";
import { getApiUrl } from "../../../utils/apiUrl";

function Comments() {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState("personas");
  const navigate = useNavigate();

  const handleRowClick = (targetUrl) => {
    if (targetUrl) navigate(targetUrl);
  };

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await fetch(getApiUrl("api/comentarios-recientes/"), {
          credentials: "include",
          cache: "no-store",
        });
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        setComments(data.filter((comment) => comment.created_by_user));
      } catch (error) {
        console.error("Failed to fetch recent comments", error);
      } finally {
        setLoading(false); // Stop loading after success or error
      }
    };

    fetchComments();
  }, []);

  const filters = [
    { key: "personas", label: "Personas" },
    { key: "iniciativas", label: "Iniciativas" },
    { key: "organizaciones", label: "Organizaciones" },
  ];
  const visibleComments = comments.filter(
    (comment) => comment.category === activeFilter,
  );

  return (
    <div id="comments-section">
      <div className="comments-header">
        <strong>Comentarios Última Semana</strong>
        <div className="comments-filters" aria-label="Filtrar comentarios por origen">
          {filters.map((filter) => (
            <button
              type="button"
              key={filter.key}
              className={`comments-filter comments-filter--${filter.key}${activeFilter === filter.key ? " is-active" : ""}`}
              aria-pressed={activeFilter === filter.key}
              onClick={() => setActiveFilter(filter.key)}
            >
              {filter.label}
              <span>{comments.filter((comment) => comment.category === filter.key).length}</span>
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <CargandoSpinner /> // Show spinner while loading
      ) : (
        <div className="comments-container">
          {visibleComments.length === 0 && (
            <p className="comments-empty">No hay comentarios de esta categoría durante la última semana.</p>
          )}
          {visibleComments.map((comment) => (
            <div
              className="comment-card"
              key={comment.key}
              onClick={() => handleRowClick(comment.target_url)}
            >
              <div className="comment-image-container">
                <PersonAvatar
                  src={comment.subject_image}
                  name={comment.subject_name}
                  alt={`Imagen de ${comment.subject_name || "el registro"}`}
                  className="comment-person-avatar"
                  tone={comment.subject_tone}
                />
              </div>
              <div className="comment-content">
                <div className="comment-context">{comment.context}: {comment.subject_name}</div>
                <div className="comment-text">{comment.comment_text}</div>
                <div className="comment-timestamp">
                  {comment.created_by_user && (
                    <PersonAvatar
                      className="comment-author-avatar"
                      src={comment.created_by_user.image}
                      name={comment.created_by_user.name || comment.created_by_user.username}
                      alt={comment.created_by_user.name || "Usuaria"}
                      tone="profesional"
                      title={
                        comment.created_by_user.name ||
                        comment.created_by_user.username ||
                        "Usuario"
                      }
                    />
                  )}
                  <span>✔️✔️ {comment.timestamp}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Comments;
